"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAirwebTicketLegacyOrderDiscountType = exports.IAirwebTicketLegacyOrderOriginType = exports.IAirwebTicketLegacyOrderProcessStatus = exports.IAirwebTicketLegacyOrderStatus = void 0;
var IAirwebTicketLegacyOrderStatus;
(function (IAirwebTicketLegacyOrderStatus) {
    IAirwebTicketLegacyOrderStatus["COMPLETED"] = "COMPLETED";
    IAirwebTicketLegacyOrderStatus["CANCELLED"] = "CANCELED";
    IAirwebTicketLegacyOrderStatus["ERROR"] = "ERROR";
    IAirwebTicketLegacyOrderStatus["PENDING"] = "PENDING";
    IAirwebTicketLegacyOrderStatus["PROCESSING"] = "PROCESSING";
    IAirwebTicketLegacyOrderStatus["REGULARIZATION"] = "REGULARIZATION";
})(IAirwebTicketLegacyOrderStatus = exports.IAirwebTicketLegacyOrderStatus || (exports.IAirwebTicketLegacyOrderStatus = {}));
var IAirwebTicketLegacyOrderProcessStatus;
(function (IAirwebTicketLegacyOrderProcessStatus) {
    IAirwebTicketLegacyOrderProcessStatus["PROCESSING"] = "PROCESSING";
    IAirwebTicketLegacyOrderProcessStatus["TO_PROCESS"] = "TO_PROCESS";
    IAirwebTicketLegacyOrderProcessStatus["PROCESSED"] = "PROCESSED";
})(IAirwebTicketLegacyOrderProcessStatus = exports.IAirwebTicketLegacyOrderProcessStatus || (exports.IAirwebTicketLegacyOrderProcessStatus = {}));
var IAirwebTicketLegacyOrderOriginType;
(function (IAirwebTicketLegacyOrderOriginType) {
    IAirwebTicketLegacyOrderOriginType["app"] = "APP";
    IAirwebTicketLegacyOrderOriginType["eshop"] = "ESHOP";
    IAirwebTicketLegacyOrderOriginType["school"] = "SCHOOL";
    IAirwebTicketLegacyOrderOriginType["retail"] = "RETAIL";
})(IAirwebTicketLegacyOrderOriginType = exports.IAirwebTicketLegacyOrderOriginType || (exports.IAirwebTicketLegacyOrderOriginType = {}));
var IAirwebTicketLegacyOrderDiscountType;
(function (IAirwebTicketLegacyOrderDiscountType) {
    IAirwebTicketLegacyOrderDiscountType["AMOUNT"] = "AMOUNT";
    IAirwebTicketLegacyOrderDiscountType["RATIO"] = "RATIO";
    IAirwebTicketLegacyOrderDiscountType["ARTICLE_AMOUNT"] = "ARTICLE_AMOUNT";
    IAirwebTicketLegacyOrderDiscountType["ARTICLE_RATIO"] = "ARTICLE_RATIO";
    IAirwebTicketLegacyOrderDiscountType["GIFT"] = "GIFT";
})(IAirwebTicketLegacyOrderDiscountType = exports.IAirwebTicketLegacyOrderDiscountType || (exports.IAirwebTicketLegacyOrderDiscountType = {}));
//# sourceMappingURL=order.interface.js.map